import {hydraUrlEngineUrl} from '../../appConfig';

function footerApiFactory(storefrontApiClient) {
  const footerApi = {
    getFooterItems(params) {
      return storefrontApiClient.get(`${hydraUrlEngineUrl}/footer`, {
        params,
      });
    },
  };

  return footerApi;
}

export default footerApiFactory;
